"use strict";
exports.__esModule = true;
var utils_1 = require("../utils");
var exceptions_1 = require("../exceptions");
function alert() {
    var defaultWatchEvents = ["alert", "confirm", "prompt"];
    var alert = window.alert, confirm = window.confirm, prompt = window.prompt;
    var config = {
        watchEvents: defaultWatchEvents,
        confirmResponse: defaultConfirmResponse,
        promptResponse: defaultPromptResponse,
        logger: console,
        randomizer: null
    };
    function defaultConfirmResponse() {
        if (config.randomizer) {
            return config.randomizer.bool();
        }
        return false;
    }
    function defaultPromptResponse() {
        if (config.randomizer) {
            return config.randomizer.sentence();
        }
        return "";
    }
    function alertMogwai() {
        if (!config.logger) {
            throw new exceptions_1.LoggerRequiredException();
        }
        if (config.watchEvents.includes("alert")) {
            window.alert = function (msg) {
                config.logger.warn("mogwai ", "alert     ", msg, "alert");
            };
        }
        if (config.watchEvents.includes("confirm")) {
            window.confirm = function (msg) {
                var out = config.confirmResponse();
                config.logger.warn("mogwai ", "alert     ", msg, "confirm");
                return out;
            };
        }
        if (config.watchEvents.includes("prompt")) {
            window.prompt = function (msg) {
                var out = config.promptResponse();
                config.logger.warn("mogwai ", "alert     ", msg, "prompt");
                return out;
            };
        }
    }
    alertMogwai.cleanUp = function () {
        window.alert = alert;
        window.confirm = confirm;
        window.prompt = prompt;
        return alertMogwai;
    };
    utils_1.configurable(alertMogwai, config);
    return alertMogwai;
}
exports.alert = alert;
